import React from 'react';

function DssReasons({ reasons }) {
  const items = Array.isArray(reasons) ? reasons.filter(Boolean) : [];
  if (items.length === 0) return null;
  return (
    <ul className="dss-reasons">
      {items.map((reason) => (
        <li key={reason}>{reason}</li>
      ))}
    </ul>
  );
}

export default DssReasons;
